export const UserType = {
  MEMBER: 'MEMBER',
  NON_MEMBER: 'NON_MEMBER'
}
